import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
    footer: {
        flexDirection: 'row',
        width: '100%',
        alignItems: 'flex-start',
        bottom: 18,
        marginLeft: 20,
        position: 'absolute',
        justifyContent: 'space-between',
    },
    currentPage: {
    },
    createdAt: {
        width: 130,
        fontSize: 8,
        textAlign: 'right',
        color: '#2A3740',
    },
    logo: {
        marginRight: 10,
        width: 20,
    },
    disclaimer: {
        flex: 1,
        marginLeft: 10,
        marginRight: 10,
        fontSize: 7,
    },
});
